var React = require('react');

function Icon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11.25 5.25004H2.87249L6.53249 1.59004C6.82499 1.29754 6.82499 0.817539 6.53249 0.525039C6.23998 0.232539 5.76749 0.232539 5.47499 0.525039L0.532485 5.46754C0.239985 5.76004 0.239985 6.23254 0.532485 6.52504L5.47499 11.4675C5.76749 11.76 6.23998 11.76 6.53249 11.4675C6.82499 11.175 6.82499 10.7025 6.53249 10.41L2.87249 6.75004H11.25C11.6625 6.75004 12 6.41254 12 6.00004C12 5.58754 11.6625 5.25004 11.25 5.25004Z","fill":"#17353B"}));
}

Icon.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none"};

module.exports = Icon;

Icon.default = Icon;
